import React from "react";

import { routes } from "utilities/routing/generatedRoutes";
import { UserAvatar } from "components/Atoms/Avatar";

declare let document: any;

interface Props {
  task: server.dto.TasksByUser
}

const TasksByUserRowCard = (props: Props) => {
  const { task } = props;
  const user = task.user;

  return (
    <div className="radius hoverable" onClick={() => {
      document.location.href = `${routes.taskManager_List().absolute}?ownerUserIds=${user.userId}`;
    }}>
      <div>
        <UserAvatar user={user} />
      </div>
      <div className="grow1">
        {user.fullName}
      </div>
      <div style={{ textAlign: "right", alignItems: "space-between" }} className="flex-column s1_small">
        <div className="s1_red grow1">
          {task.expired}
        </div>
        <div className="s1_green">
          {task.future}
        </div>
      </div>
    </div>
  );
};

export default TasksByUserRowCard;
